import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faPen, faPlus, faPrint } from '@fortawesome/free-solid-svg-icons';
import { PrinterModel } from '../printer.model';
import { PrinterService } from '../printer.service';
import { ShopModel } from '../../shops/shop.model';
import { AuthService } from 'src/app/auth/auth.service';
import { UniqueNumberValidator } from 'src/app/_common/validators/unique-number.validator';

export interface PrinterAddOrEditDialogData {
  printerModel: PrinterModel,
  isNewPrinter: boolean,
  shopList: ShopModel[]
}

@Component({
  selector: 'printer-add-or-edit-dialog',
  templateUrl: './printer-add-or-edit.dialog.html',
  styleUrls: ['./printer-add-or-edit.dialog.scss']
})

export class PrinterAddOrEditDialog implements OnInit {

  faPrint = faPrint;
  faPlus = faPlus;
  faPen = faPen;

  printerNameFormControl = new FormControl('', [Validators.required]);
  printerIpFormControl = new FormControl('', [Validators.required, Validators.pattern('^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$')]);
  printerPortFormControl = new FormControl('');
  shopSelectFormControl = new FormControl();
  isActiveFormControl = new FormControl(true);

  printerFormGroup: FormGroup;

  private originalPrinterData: any = null;

  constructor(
    public printerService: PrinterService,
    public dialogRef: MatDialogRef<PrinterAddOrEditDialog>,
    @Inject(MAT_DIALOG_DATA) public data: PrinterAddOrEditDialogData,
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    
    this.printerFormGroup = this.formBuilder.group({
      printerName: this.printerNameFormControl,
      printerIp: this.printerIpFormControl,
      printerPort: this.printerPortFormControl,
      shopSelect: this.shopSelectFormControl,
      isActive: this.isActiveFormControl,
    });

    if (!this.data.isNewPrinter) {
     this.originalPrinterData = {
        shopId: this.data.printerModel.shop?.id,
        name: this.data.printerModel.name,
        ip: this.data.printerModel.ip,
        port: this.data.printerModel.port
      };

      if (this.data.printerModel.name) {
        this.printerNameFormControl.setValue(this.data.printerModel.name);
      }
      if (this.data.printerModel.ip) {
        this.printerIpFormControl.setValue(this.data.printerModel.ip);
      }
      if (this.data.printerModel.port !== null && this.data.printerModel.port !== undefined) {
        this.printerPortFormControl.setValue(this.data.printerModel.port.toString());
      }
      if (this.data.printerModel.shop && this.data.printerModel.shop.id) {
        this.shopSelectFormControl.setValue(this.data.printerModel.shop.id);
      }
      this.isActiveFormControl.setValue(this.data.printerModel.isActive);
    }
    else {
      this.isActiveFormControl.disable();
    } 

  }

  onUniqueNumberChange(value: string) {
    if (value) {
      let formattedValue = value.replace(/\s+/g, '');
      let validChars: string[] = [];
      let letterCount = 0;

      for (let char of formattedValue) {
        if (letterCount < 3) {
          if (/[A-Za-z]/.test(char)) {
            validChars.push(char.toUpperCase());
            letterCount++;
          }
        } else {
          if (/[0-9]/.test(char)) {
            validChars.push(char);
          }
        }
      }

      formattedValue = validChars.join('');
    }
  }

  onOkClick(): void {
    this.data.printerModel.name = this.printerNameFormControl.value;
    this.data.printerModel.ip = this.printerIpFormControl.value;
    this.data.printerModel.isActive = this.isActiveFormControl.value;

    const port = this.printerPortFormControl.value;
    this.data.printerModel.port = port?.trim() ? Number(port) : null;
    this.data.printerModel.shop = this.data.shopList.filter((shop: ShopModel) => shop.id == this.shopSelectFormControl.value)[0];
    this.data.printerModel.printerType = '0';

    if (!this.data.isNewPrinter && !this.data.printerModel.id && this.originalPrinterData) {
      this.data.printerModel['oldData'] = {
        shopId: this.originalPrinterData.shopId,
        name: this.originalPrinterData.name,
        ipAddress: this.originalPrinterData.ip,
        port: this.originalPrinterData.port
      };
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

